import React from 'react';
import { formatCPF } from '../../utils/cpfValidator';
import Field from '../UI/field';

interface ICpfFieldProps {
  className?: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
}

const CpfField: React.FC<ICpfFieldProps> = ({
  className,
  label,
  value,
  onChange,
  error,
  disabled = false,
}) => {
  const handleChange = (inputValue: string) => {
    const formatted = formatCPF(inputValue);
    onChange(formatted);
  };

  return (
    <Field
      className={className}
      label={label}
      value={value}
      onChange={handleChange}
      placeholder="000.000.000-00"
      error={error}
      disabled={disabled}
    />
  );
};

export default CpfField;

